/*
 * 门票
 * */
import request from "@utils/request";


/**
 * 门票首页列表数据+搜索
 * http://shoptest.xiaojiangwh.com/api/crtips?area=忻州&keyword=五台&page=1&limit=10&lat=12.333&lng=45.6666
 * @param {*} data 
 */
export function getTicketList (data) {
    return request.get("/crtips", data);
}

/**
 * 
 * 门票详情页api
 */
/**
 * 门票详情页数据
 * http://shoptest.xiaojiangwh.com/api/crtips/detail/17252
 * @param {*} data 
 */
export function getTicketDetailData (id) {
    return request.get("crtips/detail/"+ id);
}

/**
 * 提交订单页面api
 * @param {*} data 
 * @returns 
 */
export function getTicketForScenicSpotsData (id) {
    return request.get("/crtips/confirm", {resource_id: id});
}

/**
 * 保存订单信息api
 * @param {*} id 
 * @returns 
 */
export function preservationData (data) {
    return request.post("/crtips/saveOrder", data)
}


/**
 * 获取 价格日历 api
 * @param {*} data 
 * @returns 
 */
export function getCalendarPrice (id) {
    return request.get("/crtips/pricedate", {resource_id: id})
}


/**
 * 获取订单信息 => 去支付
 * @param {*} data 
 */
export function getTicketOrderData (id) {
    return request.post("/crtips/payOrderInfo", { id});
}

/**
 * 支付接口
 * @param {*} data 
 * @returns 
 */
export function payTicket (data) {
    return request.post("/crtips/payOrder", data);
}


/**
 * 获取订单列表 全部/待付款/已完成
 * @param {*} data 
 */
export function getTicketOrderStatus () {
    return request.get("/crtips/orderData");
}


/**
 * 
 * 获取订单列表页列表数据
 */
export function getTicketOrderList (data) {
    return request.get("/crtips/orderlist", data);
}

/**
 * 
 * 获取订单详情数据
 */
export function getOrderDetailDate (id) {
    return request.get("/crtips/orderdetail/"+id);
}

/**
 * 
 * 退票申請页面信息接口
 */
export function getTicketRefundOrderDetail(id) {
    return request.get("/crtips/refundticket/"+id);
}

/**
 * 确认退票接口
 */
export function applyRefund(data) {
    return request.post("/crtips/applyRefundAll", data);
}